package com.perpheads.bans

data class Vector2(val x: Double, val y: Double) {
    operator fun plus(other: Vector2): Vector2 {
        return Vector2(x + other.x, y + other.y)
    }

    operator fun unaryMinus(): Vector2 {
        return Vector2(-x, -y)
    }
}

sealed class MapImage(
    val mapName: String,
    val image: String,
    val previewImage: String,
    val topLeft: Vector2,
    val bottomRight: Vector2
) {
    fun convertToRatios(pos: Vector2): Vector2 {
        return Vector2(
            (pos.x - topLeft.x) / (bottomRight.x - topLeft.x),
            (pos.y - topLeft.y) / (bottomRight.y - topLeft.y)
        )
    }

    fun convertToDeltaRatios(pos: Vector2): Vector2 {
        return Vector2(
            pos.x / (bottomRight.x - topLeft.x),
            pos.y / (bottomRight.y - topLeft.y)
        )
    }

    fun convertToCoordinates(ratio: Vector2): Vector2 {
        return convertToDeltaCoordinates(ratio) + Vector2(topLeft.x, topLeft.y)
    }

    fun convertToDeltaCoordinates(ratio: Vector2): Vector2 {
        return Vector2(
            ratio.x * (bottomRight.x - topLeft.x),
            ratio.y * (bottomRight.y - topLeft.y)
        )
    }

    data object ParalakeV6: MapImage(
        "rp_paralake_city_v6",
        "/assets/paralakemap_v6.png",
        "/assets/paralakemap_v6_preview.png",
        Vector2(-16760.0, 16910.0),
        Vector2(16500.0, -16190.0),
    )

    data object ParalakeV5: MapImage(
        "rp_paralake_city_v5",
        "/assets/paralakemap_v5.jpg",
        "/assets/paralakemap_v6_preview.jpg",
        Vector2(-15390.0, 14253.0),
        Vector2(14980.0, -16150.0),
    )

    companion object {
        fun fromString(name: String?): MapImage? {
            return when(name) {
                ParalakeV6.mapName -> ParalakeV6
                ParalakeV5.mapName -> ParalakeV5
                else -> null
            }
        }
    }
}

object MapSpecific {
    private val mapImages = mapOf(
        Pair("rp_paralake_city_v6", "/assets/paralakemap_v6.png"),
        Pair("rp_paralake_city_v5", "/assets/paralakemap_v5.jpg"),
    )

    fun getMapImage(mapName: String) = mapImages[mapName] ?: ""
}